import { functions } from '~/plugins/firebase'
import { httpsCallable } from 'firebase/functions'

export const callFunction = async (functionName, payload) => {
  let data
  let error
  try {
    const functionRef = httpsCallable(functions, functionName)
    const response = await functionRef(payload)
    if (response.data) {
      data = response.data
    } else {
      data = response
    }
  } catch (e) {
    error = e
  }
  return [data, error]
}
